import { AdvancedFilterInputSchema } from "@redotech/redo-model/fulfillments/fulfillment-group-summary-input";
import * as z from "zod";

export const getMerchantShippingClaimUniqueValues = {
  name: "getMerchantShippingClaimUniqueValues" as const,
  input: AdvancedFilterInputSchema.extend({
    filterName: z.string(),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
